// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1NStN","title":"InfoRow_title__1a9de"};